import { Decoder, number, object } from '@mojotech/json-type-validation'

import { SubmissionsStatus } from '@/domain/entities/submission/submissionStatus'

export const submissionsStatusDecoder: Decoder<SubmissionsStatus> = object({
  submissions: number(),
  solved: number(),
  accepted: number(),
  wrongAnswer: number(),
  timeLimit: number(),
  memoryLimit: number(),
  outputLimit: number(),
  compileError: number(),
  runtimeError: number()
})
